import * as types from 'store/projectManagerList/projectManagerListTypes'

const initialState = {
    projectManagerList: []
}

const projectManagerList = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ALL_PROJECT_MANAGERS_SUCCEEDED:
      console.log("inside fetch projectManagerList succeeded ",action)
      return {
        ...state,
        projectManagerList: action.payload,
      }
    default:
      return state
  }
}

export default projectManagerList
